<template>
  <footer>
    <div class="tomonokai">
      <img
        class="pc"
        src="@/assets/images/tomonokai.jpg"
        alt="天聖閣友の会会員募集中"
      />
      <img
        class="sp"
        src="@/assets/images/tomonokai-sp.jpg"
        alt="天聖閣友の会会員募集中"
      />
    </div>
    <div class="footer-head">
      <p>
        <span>天草の葬儀・葬式は</span>
        <span>天聖閣へお任せください。</span>
        <br />
        ご家族だけのご葬儀からご会葬の方々が多い社葬まで、ご葬家のご要望に合わせて幅広く対応いたします。
      </p>
    </div>
    <div class="footer-contents">
      <div class="footer-contents-inner">
        <div class="grid-item">
          <h3>天聖閣 本渡斎場</h3>
          <p class="address">〒863-0002 熊本県天草市本渡町本戸馬場547</p>
          <a class="tel" href="tel:0969240983">
            <img src="@/assets/images/tel-hondo.svg" alt="0969-24-0983" />
          </a>
        </div>
        <div class="grid-item">
          <h3>天聖閣 五和斎場</h3>
          <p class="address">〒863-2421 熊本県天草市五和町二江1510-1</p>
          <a class="tel" href="tel:0969330983">
            <img src="@/assets/images/tel-itsuwa.svg" alt="0969-33-0983" />
          </a>
        </div>
        <div class="grid-item">
          <h3>天聖閣 苓北斎場</h3>
          <p class="address">〒863-2507 熊本県天草郡苓北町富岡3558-4</p>
          <a class="tel" href="tel:0969350983">
            <img src="@/assets/images/tel-reihoku.svg" alt="0969-35-0983" />
          </a>
        </div>
      </div>
    </div>
    <nav class="gnav">
      <div class="gnav-inner">
        <h3>
          <a href="https://nagaitrading.co.jp">
            <img src="@/assets/images/logo_nagai.svg" alt="長井商事株式会社" />
          </a>
        </h3>
        <ul>
          <li>
            <a
              href="https://nagaitrading.co.jp"
              target="_blank"
              rel="noopener noreferrer"
            >
              長井商事株式会社トップ
            </a>
          </li>
          <li>
            <a
              href="https://nagaitrading.co.jp/ourbiz.html"
              target="_blank"
              rel="noopener noreferrer"
            >
              事業内容
            </a>
          </li>
          <li>
            <a
              href="https://nagaitrading.co.jp/philosophy.html"
              target="_blank"
              rel="noopener noreferrer"
            >
              企業理念
            </a>
          </li>
          <li>
            <a
              href="https://nagaitrading.co.jp/company.html"
              target="_blank"
              rel="noopener noreferrer"
            >
              会社概要
            </a>
          </li>
          <li>
            <a
              href="https://nagaitrading.co.jp/office.html"
              target="_blank"
              rel="noopener noreferrer"
            >
              事業所のご案内
            </a>
          </li>
        </ul>
      </div>
    </nav>
    <p class="copyright">© 2022 Nagai Trading Co.,Ltd.</p>
  </footer>
</template>

<script>
export default {};
</script>

<style scoped lang="scss">
footer {
  width: 100%;
  margin-top: 80px;

  .tomonokai {
    text-align: center;
    padding: 0 $h-gap;
    margin-bottom: 80px;
    img {
      max-width: 1000px;
      text-align: center;
      margin: 0 auto;
    }
    .pc {
      display: block;
      @include sp {
        display: none;
      }
    }
    .sp {
      display: none;
      @include sp {
        display: block;
      }
    }
  }
  .footer-head {
    background-color: $color-bg2;
    padding: $v-gap $h-gap;
    background-image: url("@/assets/images/bg-footer.jpg");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    p {
      font-size: 1.5rem;
      margin: 0 auto;
      max-width: 640px;
      text-align: center;
      line-height: 2;
      @include tb {
        font-size: 1.25rem;
      }
      span {
        display: inline-block;
      }
    }
  }
  .footer-contents {
    background-color: white;
    padding: 80px $h-gap;
    .footer-contents-inner {
      max-width: $maxwidth;
      margin: 0 auto;
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      grid-gap: $h-gap;
      @include tb {
        grid-template-columns: 1fr;
      }
      .grid-item {
        @include tb {
          text-align: center;
          padding: 0;
          padding-bottom: 1rem;
          border-bottom: 1px solid #ccc;
          &:last-child {
            border: none;
          }
        }
      }
      h3 {
        font-size: 1.5rem;
        background-image: url("@/assets/images/dots.svg");
        background-repeat: no-repeat;
        background-position: center left;
        padding-left: 1.5rem;
        margin-bottom: 0.5rem;
        @include tb {
          font-size: 1.25rem;
          display: inline-flex;
        }
      }
      .address {
        margin-bottom: 0.5rem;
        @include tb {
          font-size: 0.875rem;
        }
      }
      .tel {
        max-height: 32px;
        display: inline-block;

        img {
          width: auto;
          height: 32px;
          object-fit: contain;
          @include tb {
            height: 28px;
          }
        }
      }
    }
  }
}
.gnav {
  background-color: #eee;
  padding: 2em $h-gap;
  font-family: $sans-serif;
  .gnav-inner {
    max-width: 1280px;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
    gap: $h-gap;
    align-items: center;
    h3 {
      width: 180px;
      img {
        width: 100%;
        height: auto;
      }
      @include tb {
        text-align: center;
        margin: 0 auto;
      }
    }
    ul {
      font-weight: 600;
      color: $color-nagai;
      text-decoration: underline;
      display: flex;
      flex-wrap: wrap;
      gap: 1em 2em;
      @include tb {
        justify-content: center;
      }
    }
  }
}
.copyright {
  background-color: $color-nagai;
  font-size: 0.8rem;
  color: white;
  text-align: center;
  padding: 1em $h-gap 4em $h-gap;
  @include tb {
    text-align: left;
    height: 96px;
    display: flex;
    align-items: center;
    padding: 0 1rem 1rem 1rem;
  }
}
</style>
